import { render, staticRenderFns } from "./DocumentoPessoaInput.vue?vue&type=template&id=8ff2efc8"
import script from "./DocumentoPessoaInput.vue?vue&type=script&lang=js"
export * from "./DocumentoPessoaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports